var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0215C24.8366 32.0215 32 24.858 32 16.0215C32 7.18493 24.8366 0.0214844 16 0.0214844C7.16344 0.0214844 0 7.18493 0 16.0215C0 24.858 7.16344 32.0215 16 32.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0215C21.5652 17.4128 19.0736 20.891 16 20.891C12.9264 20.891 10.4348 17.4128 10.4348 16.0215C10.4348 12.9478 12.9264 10.4563 16 10.4563C19.0736 10.4563 21.5652 12.9478 21.5652 16.0215Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0215C21.5652 19.0951 19.0736 21.5867 16 21.5867C12.9264 21.5867 10.4348 19.0951 10.4348 16.0215",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8982 20.9406L23.3737 19.4651L24.3573 20.4488L22.8819 21.9243L21.8982 20.9406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4382 23.4L20.9137 21.9245L21.8973 22.9082L20.4219 24.3837L19.4382 23.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8494 23.8915L26.3248 22.416L27.3085 23.3997L25.833 24.8752L24.8494 23.8915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3904 26.3509L23.8658 24.8755L24.8495 25.8591L23.374 27.3346L22.3904 26.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3745 22.4162L24.85 20.9407L25.8336 21.9244L24.3582 23.3999L23.3745 22.4162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9143 24.8753L22.3898 23.3998L23.3734 24.3835L21.898 25.8589L20.9143 24.8753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8562 11.1048L20.9216 7.17016L21.9053 6.18651L25.8399 10.1211L24.8562 11.1048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9207 10.1218L19.4452 8.64638L20.4288 7.66277L21.9043 9.13823L20.9207 10.1218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3801 12.5813L21.9047 11.1058L22.8883 10.1222L24.3637 11.5976L23.3801 12.5813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8706 7.17007L22.3951 5.69461L23.3788 4.71095L24.8543 6.18642L23.8706 7.17007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3315 9.63031L24.8561 8.15484L25.8397 7.17118L27.3152 8.64665L26.3315 9.63031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 22.4134L9.6072 26.3479L8.62354 27.3316L4.68895 23.397L5.67261 22.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60596 23.3963L11.0814 24.8717L10.0978 25.8553L8.62235 24.3799L9.60596 23.3963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14697 20.9375L8.62244 22.413L7.63878 23.3966L6.16331 21.9212L7.14697 20.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62354 19.4618L12.5581 23.3963L11.5745 24.38L7.63988 20.4454L8.62354 19.4618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60645 5.69164L5.67186 9.62623L4.6882 8.64257L8.62279 4.70798L9.60645 5.69164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.082 7.16685L7.14745 11.1014L6.16379 10.1178L10.0984 6.1832L11.082 7.16685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5579 8.64345L8.62327 12.578L7.63966 11.5944L11.5742 7.65983L12.5579 8.64345Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/south-korea.15b5ed27.svg";
export { ForwardRef as ReactComponent };